// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_imG","cls2":"ProfilePdfPackCard-cls2_4Op ProfilePdfPackCard-cls1_imG"};